module.exports = __webpack_public_path__ + "static/media/tools-multiple-choice.b7fa5447.svg";